import { ListMassMailing } from '~/features/MassMailing/ListMassMailings'
import { Container } from '~/shared/ui/Layout'

export const ListMassMailingPage = () => {
  return (
    <Container>
      <ListMassMailing />
    </Container>
  )
}
